import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportcab() {



const cardData = {
  keyword: " Pune to Mumbai Airport Cab ",

"headingDescription": "Pune to Mumbai Airport Cab service is designed for travelers who need a dependable and timely transfer between Pune and Mumbai Airport. SRS Cab Service ensures a smooth long-distance journey with experienced drivers, comfortable vehicles, and precise scheduling to match your flight timings. Whether it’s an early departure or late-night arrival, our service focuses on punctual pickups, route optimization, and passenger convenience. With flexible booking options, real-time assistance, and clear pricing, your airport transfer becomes simple, efficient, and stress-free.",
"topPlaces": [
  {
    "title": "Chhatrapati Shivaji Maharaj International Airport",
    "description": "Chhatrapati Shivaji Maharaj International Airport is Mumbai’s main international gateway. Travelers booking Pune to Mumbai Airport Cab rely on timely service to reach the airport comfortably for their flights."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a popular destination located close to the airport area. Passengers using Pune to Mumbai Airport Cab often visit this beach to relax before or after their journey."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is one of Mumbai’s most famous temples dedicated to Lord Ganesha. Travelers using Pune to Mumbai Airport Cab often stop here to seek blessings."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is a modern bridge offering scenic sea views. Travelers using Pune to Mumbai Airport Cab enjoy passing through this iconic route."
  },
  {
    "title": "Phoenix Marketcity Kurla",
    "description": "Phoenix Marketcity Kurla is a major shopping and entertainment hub near the airport. Visitors using Pune to Mumbai Airport Cab often spend time here for dining and shopping."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is a calm and scenic spot near Mumbai Airport. Travelers using Pune to Mumbai Airport Cab can relax here and enjoy the peaceful surroundings."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a well-known spiritual site located in the Arabian Sea. Visitors using Pune to Mumbai Airport Cab often visit this place for a spiritual experience."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a famous seaside promenade known for its beautiful views and evening atmosphere. Travelers using Pune to Mumbai Airport Cab may explore this spot if time allows."
  },
  {
    "title": "Gateway of India",
    "description": "Gateway of India is a historic monument and a major tourist attraction in Mumbai. Travelers booking Pune to Mumbai Airport Cab often include this landmark in their itinerary."
  },
  {
    "title": "ISKCON Temple Juhu",
    "description": "ISKCON Temple Juhu is a peaceful spiritual destination dedicated to Lord Krishna. Visitors using Pune to Mumbai Airport Cab often visit this temple for a calm and devotional experience."
  }
],



services: [
{
name: "Pune to Mumbai Airport Cab Services",
description: "Pune to Mumbai Airport cab services provide reliable transportation for airport transfers. Customers can book cabs for domestic and international flights. Professional drivers ensure timely arrivals. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pune to Mumbai Airport with cab services."
},
{
name: "Pune to Mumbai Airport Taxi Booking",
description: "Pune to Mumbai Airport taxi booking offers quick and easy reservation options. Customers can book taxis online or via mobile apps. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your airport taxi from Pune easily."
},
{
name: "Pune to Mumbai Airport Car Rental",
description: "Pune to Mumbai Airport car rental provides flexible vehicle options for airport travel. Customers can choose from sedan, SUV, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars from Pune to Mumbai Airport easily."
},
{
name: "Pune to Mumbai Airport Taxi Rates",
description: "Pune to Mumbai Airport taxi rates provide clear pricing details for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune to Mumbai Airport Cab Charges",
description: "Pune to Mumbai Airport cab charges offer detailed pricing for airport transfers. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with clear charges."
},
{
name: "Pune to Mumbai Airport Car Hire",
description: "Pune to Mumbai Airport car hire offers convenient travel with driver services. Customers can hire vehicles for airport drops. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Hire cars easily for Mumbai Airport travel."
},
{
name: "Pune to Mumbai Airport Taxi Booking Online",
description: "Pune to Mumbai Airport taxi booking online provides instant reservation options. Customers can book taxis digitally with ease. Professional drivers ensure timely pickups. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your airport taxi online easily."
},
{
name: "Pune to Mumbai Airport Cabs",
description: "Pune to Mumbai Airport cabs provide reliable transportation for airport travel. Customers can choose from multiple vehicle options. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. One-way and round trip options are available. Travel easily with Pune to Mumbai Airport cabs."
},
{
name: "Pune to Mumbai Airport Cab Fare",
description: "Pune to Mumbai Airport cab fare provides clear pricing for airport transfers. Customers can check fare estimates before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with cab fare services."
},
{
name: "Pune to Mumbai Airport",
description: "Pune to Mumbai Airport service offers convenient travel for flight transfers. Customers can book cabs for timely arrivals. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Mumbai Airport."
},
{
name: "Pune Mumbai Airport Drop",
description: "Pune Mumbai airport drop provides direct one-way transportation for travelers. Customers can book cabs for convenient drop services. Professional drivers ensure timely journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose airport drop services from Pune."
},
{
name: "Pune Mumbai Cab Service",
description: "Pune Mumbai cab service offers reliable intercity transportation between two major cities. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily with Pune Mumbai cab services."
},
{
name: "Pune to Mumbai Taxi Service",
description: "Pune to Mumbai taxi service provides convenient travel for intercity journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily from Pune to Mumbai."
},
{
name: "Pune to Mumbai International Airport Cab",
description: "Pune to Mumbai international airport cab offers direct travel to major airport terminals. Customers can book cabs for timely arrivals. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily to Mumbai Airport from Pune."
},
{
name: "Pune to Mumbai Airport Cab Price",
description: "Pune to Mumbai Airport cab price provides detailed pricing for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing."
},
{
name: "Pune to Mumbai Airport Taxi",
description: "Pune to Mumbai Airport taxi offers convenient transportation for airport travel. Customers can book taxis for direct drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services to Mumbai Airport."
},
{
name: "Pune to Mumbai Airport Drop Innova",
description: "Pune to Mumbai Airport drop Innova offers premium SUV travel for airport transfers. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and group travel. Transparent pricing ensures value for money. Travel comfortably with Innova services."
},
{
name: "Pune Airport to Mumbai Cab",
description: "Pune Airport to Mumbai cab offers direct travel from Pune Airport to Mumbai. Customers can book cabs for convenient transfers. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune Airport to Mumbai."
},
{
name: "Pune Mumbai Airport Cab Service",
description: "Pune Mumbai Airport cab service provides reliable transportation for airport transfers. Customers can book cabs for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose cab services for Pune Mumbai Airport travel."
},
{
name: "Pune Mumbai Airport Car",
description: "Pune Mumbai Airport car service offers convenient travel with multiple vehicle options. Customers can choose vehicles based on needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car services."
},
{
name: "Pune Mumbai Airport Car Hire",
description: "Pune Mumbai Airport car hire provides flexible travel solutions with driver options. Customers can hire cars for airport transfers. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Hire cars easily for airport travel."
},
{
name: "Pune Mumbai Airport Drop Taxi",
description: "Pune Mumbai Airport drop taxi offers direct transportation for airport travel. Customers can book taxis for convenient drop services. Professional drivers ensure timely journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose drop taxi services easily."
},
{
name: "Pune Mumbai Drop",
description: "Pune Mumbai drop service provides simple and reliable intercity travel. Customers can book cabs for direct journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Pune Mumbai drop services."
},
{
name: "Pune Mumbai Taxi Service Fare",
description: "Pune Mumbai taxi service fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent fare."
},
{
name: "Pune to Mumbai Airport Cab Time",
description: "Pune to Mumbai Airport cab time provides travel duration details for planning trips. Customers can estimate journey time easily. Professional drivers ensure timely arrivals. Comfortable vehicles enhance travel experience. Flexible booking options are available. Plan your airport travel with accurate timing."
}
],

tableData: [
["Pune to Mumbai Airport Cab Services","Pune to Mumbai Airport Taxi Booking"],
["Pune to Mumbai Airport Car Rental","Pune to Mumbai Airport Taxi Rates"],
["Pune to Mumbai Airport Cab Charges","Pune to Mumbai Airport Car Hire"],
["Pune to Mumbai Airport Taxi Booking Online","Pune to Mumbai Airport Cabs"],
["Pune to Mumbai Airport Cab Fare","Pune to Mumbai Airport"],
["Pune Mumbai Airport Drop","Pune Mumbai Cab Service"],
["Pune to Mumbai Taxi Service","Pune to Mumbai International Airport Cab"],
["Pune to Mumbai Airport Cab Price","Pune to Mumbai Airport Taxi"],
["Pune to Mumbai Airport Drop Innova","Pune Airport to Mumbai Cab"],
["Pune Mumbai Airport Cab Service","Pune Mumbai Airport Car"],
["Pune Mumbai Airport Car Hire","Pune Mumbai Airport Drop Taxi"],
["Pune Mumbai Drop","Pune Mumbai Taxi Service Fare"],
["Pune to Mumbai Airport Cab Time","Pune to Mumbai Airport Cab Services"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Airport Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers familiar with Pune to Mumbai Airport routes via expressway, ensuring smooth navigation and timely airport drop."
  },
  {
    WhyChooseheading: "On-Time Airport Drop Guarantee",
    WhyChoosedescription: "We ensure punctual Pune to Mumbai Airport cab service so you reach the airport well before your flight without stress or delays."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "SRS Cab Service offers budget-friendly airport cab services with clear pricing. Customers receive full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Pune to Mumbai Airport cab service operates 24/7, making it convenient for early morning flights, late-night travel, and emergency bookings."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles to ensure a comfortable journey from Pune to Mumbai Airport."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, Kharadi, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Mumbai Airport cab bookings due to punctual drivers, reliable vehicles, and professional service."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Mumbai Airport cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Mumbai Airport." },
  { question: "How far is Mumbai Airport from Pune?", answer: "The distance is approximately 150 km and the journey takes around 3 to 4 hours depending on traffic." },
  { question: "Is Pune to Mumbai Airport cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for airport travel." },
  { question: "Which airport terminals do you cover?", answer: "We provide drop services to all terminals including T1 and T2 of Mumbai Airport." },
  { question: "Which vehicles are available for airport transfer?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way airport cab?", answer: "Yes, we provide one-way and round-trip airport cab services." },
  { question: "Do you provide doorstep pickup in Pune?", answer: "Yes, we provide pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Mumbai Airport cab service online or via phone." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Sharma",
    feedback:
      "Booked SRS Cab Service for Mumbai Airport drop. Reached on time without any hassle. Excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Anjali Mehta",
    feedback:
      "Very reliable Pune to Mumbai Airport cab service. Clean car and professional driver.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Mumbai Airport cab services including taxi booking, car rentals, airport drop, one-way and round trips. Travel safely and comfortably from Pune to Mumbai Airport with affordable fares and 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};














  return (
    <div>
      

<Helmet>
  <title>Pune to Mumbai Airport Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Airport cabs with SRS Cab. Taxi booking, car rentals, airport drop, one-way and round trips from Pune to Mumbai Airport. Safe and comfortable rides with 24x7 online booking and affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportcab;